import { Select, SelectProps, TreeSelect, TreeSelectProps } from 'antd'
import React from 'react'
import { FilterSelectPc } from '../FilterSelect/FilterSelectPc';
import { useSearchConditionPc } from '../hooks/useSearchCondition';

const Option = Select.Option;

export interface FilterGoodsBrandPcProps extends SelectProps{

}
const FilterGoodsBrandPc = (props: FilterGoodsBrandPcProps)=> {
    const { value , placeholder='商品品牌',  ...rest } = props
    const { searchCondition, loading, getInitData } =  useSearchConditionPc({ goods: ['brand_filter_permission','brand'] })
    const goods = searchCondition.goods
    return (
        <FilterSelectPc
            allowClear
            dropdownStyle={{ maxHeight: 400,  overflow: "auto" ,minWidth:400}}
            style={{width:'100%'}}
            value={value}
            placeholder={placeholder}
            defaultFilterOption
            loading={loading}
            getInitData={getInitData}
            options={goods ? goods.brand_filter_permission || goods.brand || []: []}
            {...rest}
        />
    )
}
export default FilterGoodsBrandPc;